import classNames from 'classnames';
import EditableDatePicker from '../../../components/forms/editableDatePicker.jsx';
import LayoutCheckbox from '../../../components/forms/layoutCheckbox.jsx';
import LayoutInput from '../../../components/forms/layoutInput.jsx';
import LayoutSelect from '../../../components/forms/layoutSelect.jsx';
import MaintenanceSteps from './maintenanceSteps.jsx';
import path from 'path';
import PropTypes from 'prop-types';
import React from 'react';
import ToolTip, {tooltipPositions} from '../../../components/ToolTip.jsx';
import {balanceColumns} from '../../../helpers/fieldHelpers.jsx';
import {
  chemicalBaseTypes,
  systemTypes,
  truBlueStatus,
} from '../../../helpers/constants.jsx';
import {events} from 'lib';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {optimizerPlusTitle} from '../../../helpers/dataHelpers.jsx';
import {inSoftSoakTrioRange} from 'helpers/regionalDifferences';
import {countries} from 'helpers/constants';
import {getLanguageFromLocale, getTranslatedAssetFileName} from 'helpers/languageHelper';


const displayProductName = {
  sanitizer: 'Sanitizer',
  usingOptimizerPlus: 'Optimizer Plus',
  maintClarifier: 'Maintenance Clarifier',
  prevAlgicide: 'Prev Algicide',
  maintOxidizer: 'Maint Oxidizer',
};

class SystemChemicals extends React.Component {
  static defaultProps = {condition: true};

  static propTypes = {
    branch: PropTypes.object.isRequired,
    condition: PropTypes.bool,
    customer: PropTypes.object,
    dataChanged: PropTypes.func.isRequired,
    dealer: PropTypes.object,
    edit: PropTypes.bool.isRequired,
    editTruBlueState: PropTypes.func,
    pool: PropTypes.object.isRequired,
    poolWorkingCopy: PropTypes.object,
    productDict: PropTypes.object.isRequired,
    products: PropTypes.array,
    group: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    changedFields: undefined,
  };

  componentDidMount() {
    this.pageChangeHandler = events.subscribe('page-change', () => {
      if (this.state.changedFields) {
        this.truBlueWarnings();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.changedFields && this.state.changedFields && this.props.condition && prevProps.condition) {
      this.truBlueWarnings();
    }
  }

  componentWillUnmount() {
    this.pageChangeHandler.remove();
  }

  getSeasonsUsageReport = () => {
    if (!this.props.pool.id) {
      return;
    }

    return path.join(window.location.hash, '..', 'season-usage');
  };

  truBlueWarnings = () => {
    let {formatMessage} = this.props.intl;

    this.highlightFields(this.state.changedFields);
    events.publish('warn.user', {
      message: formatMessage({
        id: 'chemicals.following.products.changed',
        values: {
          products: this.state.changedFields
            .map(x => displayProductName[x])
            .join(', '),
        },
      }),
    });
    this.setState({
      changedFields: undefined,
    });
  };

  highlightFields = (fields) => {
    for (let f of fields) {
      if (this[f]) {
        this[f].highlight();
      }
    }
  };

  render() {
    const dealer = this.props.dealer;
    let pool = this.props.pool;
    let {formatMessage, locale} = this.props.intl;
    let productDict = this.props.productDict;
    let chemicalBaseTypeID = this.props.productDict && this.props.productDict.sanitizer && this.props.productDict.sanitizer.chemicalBaseType ?
      this.props.productDict.sanitizer.chemicalBaseType : chemicalBaseTypes.chlorinePool;

    let products = [];

    const isUS = dealer.country === 'US';
    const isCanada = dealer.country === 'CA';
    const language = getLanguageFromLocale(locale);

    products.push(<LayoutSelect editMode={this.props.edit}
                                label={formatMessage({id: 'customer.product.profile.troubleshooting'})}
                                dataKey='oxidizer'
                                key='oxidizer'
                                value={productDict.oxidizer.current}
                                dataChanged={this.props.dataChanged}
                                options={productDict.oxidizer.names}
                                keys={productDict.oxidizer.keys}/>);

    products.push(<LayoutSelect editMode={this.props.edit}
                                label={formatMessage({id: 'customer.product.profile.phadjuster'})}
                                dataKey='pHAdjuster'
                                key='pHAdjuster'
                                value={productDict.pHAdjuster.current}
                                dataChanged={this.props.dataChanged}
                                options={productDict.pHAdjuster.names}
                                condition={pool.typeID !== systemTypes.spa}
                                keys={productDict.pHAdjuster.keys}/>);

    products.push(<LayoutSelect editMode={this.props.edit}
                                label={formatMessage({id: 'general.ph.buffer'})}
                                dataKey='pHBuffer'
                                key='pHBuffer'
                                value={productDict.pHBuffer.current}
                                condition={pool.typeID === systemTypes.spa && !pool.softSoakTRIO &&
                                productDict.sanitizer.currentName !== 'Saltwater Spa' && !pool.usingVanishingAct}
                                dataChanged={this.props.dataChanged}
                                options={productDict.pHBuffer.names}
                                keys={productDict.pHBuffer.keys}/>);

    products.push(<LayoutSelect editMode={this.props.edit}
                                label={formatMessage({id: 'general.maint.clarifier'})}
                                dataKey='maintClarifier'
                                key='maintClarifier'
                                value={productDict.maintClarifier.current}
                                dataChanged={this.props.dataChanged}
                                options={productDict.maintClarifier.names}
                                condition={pool.typeID === systemTypes.pool || pool.typeID === systemTypes.swimspa}
                                ref={r => this.maintClarifier = r}
                                keys={productDict.maintClarifier.keys}/>);

    products.push(<LayoutSelect editMode={this.props.edit}
                                label={formatMessage({id: 'customer.product.profile.winterizer'})}
                                dataKey='winterOxidizer'
                                key='winterOxidizer'
                                value={productDict.winterOxidizer.current}
                                dataChanged={this.props.dataChanged}
                                options={productDict.winterOxidizer.names}
                                condition={pool.typeID !== systemTypes.spa}
                                keys={productDict.winterOxidizer.keys}/>);

    if (productDict.winterOxidizer.names.length > 0) {
      if (productDict.winterOxidizer.currentName.includes('Shock')) {
        products.push(<LayoutSelect editMode={this.props.edit}
                                    label={formatMessage({id: 'chemicals.winter.algicide'})}
                                    dataKey='winterAlgicide'
                                    key='winterAlgicide'
                                    value={productDict.winterAlgicide.current}
                                    dataChanged={this.props.dataChanged}
                                    options={productDict.winterAlgicide.names}
                                    keys={productDict.winterAlgicide.keys}/>);
      } else {
        products.push(<div key='alignment'/>);
      }
    }

    products.push(<LayoutSelect editMode={this.props.edit}
                                label={formatMessage({id: 'general.stabilizer'})}
                                dataKey='stabilizer'
                                key='stabilizer'
                                value={productDict.stabilizer.current}
                                dataChanged={this.props.dataChanged}
                                options={productDict.stabilizer.names}
                                keys={productDict.stabilizer.keys}
                                ref={r => this.stabilizer = r}
                                condition={pool.typeID === systemTypes.pool &&
                                [
                                  chemicalBaseTypes.chlorinePool,
                                  chemicalBaseTypes.mineralSpringsPool,
                                  chemicalBaseTypes.saltWaterPool,
                                  chemicalBaseTypes.synergyPool,
                                ].includes(chemicalBaseTypeID)}
    />);

    products.push(<LayoutInput
      label={this.props.productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.mineralSpringsPool ?
        formatMessage({id: 'chemicals.ideal.mineral.ppm'}) :
        formatMessage({id: 'chemicals.ideal.salt.ppm'})}
      dataKey='idealSaltPPM'
      value={pool.idealSaltPPM}
      dataChanged={this.props.dataChanged}
      group={this.props.group}
      validate={val => !val && val !== 0 || val > 0 && val <= 9999}
      validateMessage={
        <React.Fragment>
          {this.props.productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.mineralSpringsPool ?
            <FormattedMessage id='chemicals.ideal.mineral.ppm'/> :
            <FormattedMessage id='chemicals.ideal.salt.ppm'/>}
          &nbsp;<FormattedMessage id='chemicals.must.be.empty'/>
        </React.Fragment>}
      beforeFocus={() => location.hash = path.join(location.hash, '..', 'chemicals')}
      type='number'
      editMode={this.props.edit}
      condition={this.props.productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.mineralSpringsPool ||
        this.props.productDict.sanitizer.currentName === 'Saltwater Spa' ||
        this.props.productDict.sanitizer.currentName === 'Saltwater' ||
        this.props.productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.saltWaterSpa ||
        this.props.productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.saltWaterPool}/>);


    let productColumns;

    {
      this.props.dealer.isTruBlueEligible && !pool.isTruBlueIneligible ?
        productColumns = <div className="container">
          <div className="row">
            <div className="col-sm-7">{balanceColumns(products, 2)}</div>
            <div className="col-sm-5">
              <i className={classNames('bl', 'icon', 'bl-tru-blue-icon bl-tru-blue-filled', {
                'blue': pool.truBlueStatus === truBlueStatus.Active,
                'grey': pool.truBlueStatus === truBlueStatus.Inactive ||
                pool.truBlueStatus === truBlueStatus.Eligible ||
                pool.truBlueStatus === truBlueStatus.Opportunity,
              })}>
                <span>{pool.truBlueStatus === truBlueStatus.Active ? formatMessage({id: 'general.active'}) :
                          pool.truBlueStatus === truBlueStatus.Inactive ? formatMessage({id: 'general.inactive'}) :
                            pool.truBlueStatus === truBlueStatus.Eligible ? formatMessage({id: 'general.eligible'}) :
                              formatMessage({id: 'general.opportunity'})}</span>
              </i>
              <img src={'Content/img/' + getTranslatedAssetFileName({filename: 'BTBP-PMS-Logo',ext: '.svg', language: language})}
                   alt='TruBlue Logo'
                   height='62'
                   className='trublue-logo'/>
            </div>
          </div>
        </div> :
        productColumns = balanceColumns(products, 3);
    }

    let enhancers = [];

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={optimizerPlusTitle(this.props.branch, pool, formatMessage)}
                                   dataKey='usingOptimizerPlus'
                                   key='usingOptimizerPlus'
                                   ref={r => this.usingOptimizerPlus = r}
                                   value={pool.usingOptimizerPlus}
                                   disabled={productDict.sanitizer.chemicalBaseType === chemicalBaseTypes.mineralSpringsPool}
                                   dataChanged={this.props.dataChanged}
                                   condition={(dealer.country === countries.CA || pool.typeID !== systemTypes.spa) &&
                                    productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.synergyPool &&
                                    productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.synergySpa}/>);

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={formatMessage({id: 'general.natural.result'})}
                                   dataKey='usingNaturalResult'
                                   key='usingNaturalResult'
                                   value={pool.usingNaturalResult}
                                   dataChanged={this.props.dataChanged}
                                   condition={pool.typeID === systemTypes.pool}/>);

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={formatMessage({id: 'general.smart.shield'})}
                                   dataKey='usingSmartShield'
                                   key='usingSmartShield'
                                   value={pool.usingSmartShield}
                                   dataChanged={this.props.dataChanged}
                                   condition={pool.typeID === systemTypes.pool && isCanada} />);

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={formatMessage({id: 'chemicals.using.vanishing.act'})}
                                   dataKey='usingVanishingAct'
                                   key='usingVanishingAct'
                                   condition={pool.typeID === systemTypes.spa && isUS &&
                                   this.props.productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.softSoakSpa}
                                   value={pool.usingVanishingAct}
                                   dataChanged={this.props.dataChanged}/>);

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={formatMessage({id: 'chemicals.natural.spa.enzyme'})}
                                   dataKey='enzymes'
                                   key='enzymes'
                                   value={pool.enzymes}
                                   dataChanged={this.props.dataChanged}
                                   condition={(pool.typeID === systemTypes.spa || pool.typeID === systemTypes.swimspa)}/>);

    enhancers.push(<LayoutCheckbox label={formatMessage({id: 'chemicals.softsoak.trio'})}
                                   dataKey='softSoakTRIO'
                                   value={pool.softSoakTRIO}
                                   dataChanged={this.props.dataChanged}
                                   condition={parseInt(pool.typeID) === systemTypes.spa &&
                                     this.props.productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.softSoakSpa &&
                                     inSoftSoakTrioRange(dealer, pool) &&
                                     this.props.productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.synergySpa}
                                   editMode={this.props.edit}/>);

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={formatMessage({id: 'chemicals.oxysheen'})}
                                   dataKey='oxysheenTreatment'
                                   key='oxysheenTreatment'
                                   condition={chemicalBaseTypeID === chemicalBaseTypes.softswimPool && isUS}
                                   value={pool.oxysheenTreatment}
                                   dataChanged={this.props.dataChanged}/>);

    enhancers.push(<LayoutCheckbox editMode={this.props.edit}
                                   label={formatMessage({id: 'chemicals.pool.opening.complete'})}
                                   dataKey='poolOpeningComplete'
                                   key='poolOpeningComplete'
                                   condition={pool.typeID === systemTypes.pool && isUS}
                                   value={pool.poolOpeningComplete}
                                   dataChanged={this.props.dataChanged}/>);

    enhancers.push(<LayoutCheckbox label={formatMessage({id: 'chemicals.spa.complete'})}
                                   dataKey='spaComplete'
                                   value={pool.spaComplete}
                                   dataChanged={this.props.dataChanged}
                                   condition={parseInt(pool.typeID) === systemTypes.spa &&
                                   this.props.productDict.sanitizer.chemicalBaseType !== chemicalBaseTypes.softSoakSpa}
                                   editMode={this.props.edit}/>);


    let enhancerColumns = balanceColumns(enhancers, 3);

    let stepFields = [];

    stepFields.push(<LayoutSelect editMode={this.props.edit}
                                  label={formatMessage({id: 'general.sanitizer'})}
                                  dataKey='sanitizer'
                                  key='sanitizer'
                                  value={productDict.sanitizer.current}
                                  ref={r => this.sanitizer = r}
                                  dataChanged={this.props.dataChanged}
                                  options={productDict.sanitizer.names}
                                  keys={productDict.sanitizer.keys}/>);

    stepFields.push(<LayoutSelect editMode={this.props.edit}
                                  label={formatMessage({id: 'general.maint.oxidizer'})}
                                  dataKey='maintOxidizer'
                                  key='maintOxidizer'
                                  ref={r => this.maintOxidizer = r}
                                  value={productDict.maintOxidizer.current}
                                  dataChanged={this.props.dataChanged}
                                  options={productDict.maintOxidizer.names}
                                  keys={productDict.maintOxidizer.keys}/>);

    stepFields.push(<LayoutSelect editMode={this.props.edit}
                                  label={formatMessage({id: 'general.prev.algicide'})}
                                  dataKey='prevAlgicide'
                                  key='prevAlgicide'
                                  ref={r => this.prevAlgicide = r}
                                  value={productDict.prevAlgicide.current}
                                  dataChanged={this.props.dataChanged}
                                  condition={pool.typeID === systemTypes.pool || pool.typeID === systemTypes.swimspa}
                                  options={productDict.prevAlgicide.names}
                                  keys={productDict.prevAlgicide.keys}/>);

    let steps = !this.props.edit ?
      <MaintenanceSteps productDict={productDict}
                        pool={this.props.pool} language={language}/> :
      <div className='row'>
        {stepFields.map((sf, i) => <div className='col-xs-4'
                                        key={i}>{sf}</div>)}
      </div>;

    let output =
      <div className='system-chemicals container'>
        <div className='col-xs-12'>{steps}</div>
        <h2 className='with-keyline'><FormattedMessage id="chemicals.water.enhancers"/></h2>
        {enhancerColumns}
        <h2 className='with-keyline'><FormattedMessage id="general.other"/></h2>
        {productColumns}
        <div className='highlighted containe'>
          <label><FormattedMessage id="chemicals.season.usage.dates"/></label>
          <ToolTip title={formatMessage({id: 'chemicals.season.shopping.tooltip'})}
                   position={tooltipPositions.topRight}
                   iconOnly
                   style={{float: 'right'}}/>
          <div className='form-control-static'>
            <FormattedMessage id='general.date.range' values={{
              start: <EditableDatePicker
                editMode={this.props.edit}
                value={pool.seasonStart}
                onChange={this.props.dataChanged}
                dataKey='seasonStart'
                dateFormat='MMMM D'
                data-event-category='User'
                data-event-action='date-season-usage'
                style={{display: 'inline-block'}}/>,
              end: <EditableDatePicker
                editMode={this.props.edit}
                value={pool.seasonEnd}
                onChange={this.props.dataChanged}
                dataKey='seasonEnd'
                dateFormat='MMMM D'
                data-event-category='User'
                data-event-action='date-season-usage'
                style={{display: 'inline-block'}}/>,
            }}/>

            {this.props.productDict.sanitizer.currentName !== 'Saltwater Spa' ?
              <a className='pull-right btn-primary btn'
                 href={this.getSeasonsUsageReport()}
                 disabled={!this.props.pool.id}><FormattedMessage
                id="chemicals.season.shopping.list"/></a> :
              null}
          </div>
        </div>
      </div>;

    return this.props.condition ? output : null;
  }
}

export default injectIntl(SystemChemicals);
